import {Component, OnInit, ViewChild} from '@angular/core';
import {RangeDateScreenerFilterModel} from '../../iBoxx/modals/RangeDateScreenerFilterModel';
import {DataSharingService} from '../../iBoxx/services/data-sharing.service';
import {LoaderService} from '../../iBoxx/shared/loader/loader-service.services';
import {ApiService} from '../../iBoxx/services/api.service';
import {UtilService} from '../../iBoxx/services/UtilService';
import {Router} from '@angular/router';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap';
import {ChartPageComponent} from '../../iBoxx/chart-page/chart-page.component';

@Component({
  selector: 'app-emix-details-page',
  templateUrl: './emix-details-page.component.html',
  styleUrls: ['./emix-details-page.component.scss'],
})
export class EmixDetailsPageComponent implements OnInit {

  @ViewChild(ChartPageComponent) chartPage: ChartPageComponent | undefined;

  tabList: string[] = [];
  currentTab = '';
  currentID = '';
  indexType = 'all';
  response: any = undefined;
  chartDataLoaded = false;
  resetDropdown = false;
  chartSetting = 'default';
  chartType = 'single';
  chartDataFetching = false;
  currentPeriod = '';
  currentTimeSeries = '';
  chartData = {
    chartSeries: {
      data: [],
      max: null,
      min: null,
      name: this.currentTimeSeries,
      unit: null},
    selectedPeriod: '',
    selectedTimeSeries: ''};
  chartDatas = [];
  profileData: any;
  profileLoading = false;
  constituentData: any;
  dateRange: RangeDateScreenerFilterModel = new RangeDateScreenerFilterModel();
  periodData = ['YTD', '1W', '1M', '3M', '6M', '1Y', '3Y', '5Y', '10Y'];
  period: any;
  compareFilterData = ['Unrebased', 'Rebased'];
  compare: any;
  isRebased = true;
  timeSeriesData = ['Price', 'Net Total Return', 'Gross Total Return'];
  timeSeries: any;
  compareData: any;
  indexToCompare = [''];
  // cards = ['CHART', 'INDEX PROFILE', 'INDEX PERFORMANCE & ANALYTICS', 'CONSTITUENT'];
  cards = ['CHART', 'CONSTITUENT'];
  visibleCards = ['chart', 'profile', 'analytics', 'constituent'];
  selectedTimeSeries = '';
  selectedPeriod = '';
  selectedFromDate = '';
  selectedToDate = '';
  expanded = false;
  currentCard = '';
  currentView = [];

  // ALERT VIEW
  showAlert1 = false;
  showAlert2 = false;
  showAlert3 = false;
  alert1 = '';
  alert2 = '';
  alert3 = '';
  alertType = 'info';
  indexNotInHeadline = false;
  indexNotFoundMsg = 'Invalid Request.';
  chartFilters = [];
  constructor(private shareService: DataSharingService, private loader: LoaderService, private apiService: ApiService,
              public utilService: UtilService, private route: Router) { }

  ngOnInit(): void {
    // @ts-ignore
    this.tabList = JSON.parse(window.sessionStorage.getItem('tabListForEMIX')) ? JSON.parse(window.sessionStorage.getItem('tabListForEMIX'))
      : ['screener', 'documentation'];
    // @ts-ignore
    this.currentView = JSON.parse(localStorage.getItem('tabViewState')) ? JSON.parse(localStorage.getItem('tabViewState')) : [];
    this.currentTab = this.shareService.currentTab;
    // @ts-ignore
    this.chartFilters = JSON.parse(localStorage.getItem('chartFilterOptions')) ? JSON.parse(localStorage.getItem('chartFilterOptions'))
      : [];

    const urlSub = this.shareService.indexURL.subscribe((resp: any) => {
      this.currentID = resp.split('=')[1];
      this.fetchChartOptions();
      this.fetchDetailsForID(this.currentID);
      if (this.currentTab.length > 0) {
        if (this.currentView.find((view: any) => view.tabName === this.currentTab)) {
          this.repopulateView();
        } else {
          this.storeView();
        }
      }
    });
    if (urlSub) {
      urlSub.unsubscribe();
    }
  }

  initialiseDropDown(): void {
    this.period = {
      label: '',
      options: []
    };
    this.timeSeries = {
      label: '',
      options: []
    };
    this.compareData = {
      label: '',
      options: []
    };
    this.compare = {
      label: '',
      options: []
    };
  }

  initDropDown(): void {
    this.period.options.push({
      label: 'No period selected',
      value: 'No period selected',
      selected: false
    });
    this.periodData.forEach((pd: string) => {
      this.period.options.push({
        label: pd,
        value: pd,
        selected: pd === (this.selectedPeriod ? this.selectedPeriod : this.periodData[0])
      });
    });
    this.compareFilterData.forEach((data: string) => {
      this.compare.options.push({
        label: data,
        value: data,
        selected: data === (this.isRebased ? 'Rebased' : 'Unrebased')
      });
    });
    this.initTimeSeriesDropDown();
  }

  initTimeSeriesDropDown(): void {
    this.timeSeries.options = [];
    this.timeSeriesData.forEach((ts: string) => {
      this.timeSeries.options.push({
        label: ts,
        value: ts,
        selected: ts === (this.selectedTimeSeries ? this.selectedTimeSeries : this.timeSeriesData[0])
      });
    });
  }

  initCompareChartDropdown(): void{
    this.compareData.options = [];
    const selectedIndices = this.shareService.EMIXIndices.indexLevels
      .filter((index: any) => this.indexToCompare.includes(index.id) && index.id !== this.response.id)
      .map((index: any) => index.indexName + ' (' + index.currency + ')');

    const indexToCompare = this.shareService.EMIXIndices.indexLevels.filter((index: any) => index.id !== this.response.id
      && index.currency === this.response.currency);
    indexToCompare.forEach((index: any) => {
      this.compareData.options.push({
        label: index.indexName + ' (' + index.currency + ')',
        value: index.indexName + ' (' + index.currency + ')',
        selected: selectedIndices.includes(index.indexName + ' (' + index.currency + ')')
      });
    });
    setTimeout(() => {
      this.resetDropdown = true;
    }, 10);
  }

  reinitialisePeriodPicker(): void {
    this.period = {
      label: '',
      options: []
    };
    this.period.options.push({
      label: 'No period selected',
      value: 'No period selected',
      selected: true
    });
    this.periodData.forEach((pd: string) => {
      this.period.options.push({
        label: pd,
        value: pd,
        selected: false
      });
    });
  }

  storeChartOption(currentId: string, currentPeriod: string, currentTimeSeries: string, toDate: string, fromDate: string,
                   chartType: string, indicesOnChart: string[]): void {
    const options = {
      id: currentId,
      periodType: currentPeriod === 'No period selected' ? 'custom' : currentPeriod,
      timeSeries: currentTimeSeries,
      toDate,
      fromDate,
      chartType,
      indicesOnChart,
      isRebased: this.isRebased
    };
    const index = this.chartFilters.findIndex((filter: any) => filter.id === this.currentID);
    if (index > -1) {
      // @ts-ignore
      this.chartFilters.splice(index, 1, options);
    } else {
      // @ts-ignore
      this.chartFilters.push(options);
    }
    localStorage.setItem('chartFilterOptions', JSON.stringify(this.chartFilters));
  }

  fetchChartOptions(): void {
    // @ts-ignore
    const filtersValue = JSON.parse(localStorage.getItem('chartFilterOptions')) ? JSON.parse(localStorage.getItem('chartFilterOptions'))
      : [];
    if (filtersValue !== null){
      filtersValue.forEach((filter: any) => {
        if (filter.id === this.currentID) {
          this.selectedTimeSeries = filter.timeSeries;
          this.selectedPeriod = filter.periodType;
          this.selectedFromDate = filter.fromDate;
          this.selectedToDate = filter.toDate;
          this.currentPeriod = filter.periodType;
          this.currentTimeSeries = filter.timeSeries;
          this.chartType = filter.chartType;
          this.indexToCompare = filter.indicesOnChart;
          this.isRebased = filter.isRebased;
        }
      });
      this.initialiseDropDown();
      this.initDropDown();
    }
  }

  getFromAndToDate(): void{
    if (this.dateRange.ngbFromDate && this.dateRange.ngbFromDate) {
      // @ts-ignore
      this.selectedFromDate = this.dateRange.ngbFromDate.month + '/' + this.dateRange.ngbFromDate.day
        + '/' + this.dateRange.ngbFromDate.year;
      // @ts-ignore
      this.selectedToDate = this.dateRange.ngbToDate.month + '/' + this.dateRange.ngbToDate.day + '/' + this.dateRange.ngbToDate.year;
    }else{
      this.selectedFromDate = '';
      this.selectedToDate = '';
    }
  }

  getIndexValue(tabName: string): void {
    switch (tabName) {
      case 'screener':
        this.route.navigateByUrl('EMIX/Screener');
        break;
      case 'documentation':
        this.route.navigateByUrl('EMIX/docs/page?docFor=EMIX');
        break;
      default:
        const index = this.shareService.EMIXIndices.indexLevels.find((level: any) => tabName === (level.indexName + ' (' + level.currency + ')'));
        if (index.id !== this.response.id) {
          window.location.href = window.location.href.split('=')[0] + '=' + index.id;
        }
        break;
    }
  }

  applyPeriodFilter(event: any): void {
    this.currentPeriod = event.value;
    if (this.currentPeriod === 'No period selected'){
      if (!this.dateRange.ngbFromDate && !this.dateRange.ngbToDate){
        this.removeChart();
      }else{
        this.currentPeriod = 'custom';
      }
    }
    if (this.chartType === 'multi' && this.currentPeriod !== 'custom'){
      this.dateRange = new RangeDateScreenerFilterModel();
      this.fetchChartDataToCompareFor();
    }else if (this.currentID.length > 0 && this.currentPeriod !== 'custom' && this.currentPeriod !== 'No period selected' &&
      (this.chartType || this.chartType === 'single')) {
      this.fetchChartDataFor(this.currentID, this.currentPeriod, this.currentTimeSeries);
    }
    this.storeChartOption(this.currentID, this.currentPeriod, this.currentTimeSeries, '', '', this.chartType, this.indexToCompare);
  }

  setDateRange(event: any): void {
    if (event.ngbFromDate && event.ngbToDate) {
      const from = event.ngbFromDate.month + '/' + event.ngbFromDate.day + '/' + event.ngbFromDate.year;
      const to = event.ngbToDate.month + '/' + event.ngbToDate.day + '/' + event.ngbToDate.year;
      const maxDate = event.maxDate.month + '/' + event.maxDate.day + '/' + event.maxDate.year;
      const minDate = event.minDate.month + '/' + event.minDate.day + '/' + event.minDate.year;
      if (!isNaN(new Date(from).getTime()) && !isNaN(new Date(to).getTime())
        && (new Date(from).getTime() >= new Date(minDate).getTime())
        && (new Date(to).getTime() <= new Date(maxDate).getTime())) {
        this.currentPeriod = 'custom';
        this.reinitialisePeriodPicker();
        // @ts-ignore
        const validPeriod = (new Date(new Date().getFullYear() - 10, new Date().getMonth(), new Date().getDate()) - new Date(from)) <= 0;
        if (validPeriod) {
          this.storeChartOption(this.currentID, this.currentPeriod, this.currentTimeSeries, to, from, this.chartType, this.indexToCompare);
          if (this.chartType === 'multi') {
            this.fetchChartDataToCompareFor();
          }else{
            this.fetchCustomChartDataFor(this.response.id, from, to);
          }
        }else{
          this.indexNotFoundMsg = 'Can only select period within last 10 years.';
          this.indexNotInHeadline = true;
        }
      }
    }
  }

  applyTimeSeriesFilter(event: any): void {
    this.currentTimeSeries = event.value;
    this.chartSetting = this.currentTimeSeries === 'Price' && this.indexToCompare.length === 1 ? 'default' : 'custom';
    this.getFromAndToDate();
    // @ts-ignore
    let validPeriod = (new Date(new Date().getFullYear() - 10, new Date().getMonth(), new Date().getDate())
    // @ts-ignore
      - new Date(this.selectedFromDate)) <= 0;
    if (this.currentPeriod !== 'custom'){
      validPeriod = true;
    }
    if (validPeriod) {
      if (this.currentPeriod === 'custom' || this.currentPeriod === 'No period selected') {
        this.loader.show();
        if (this.chartType === 'multi') {
          this.fetchChartDataToCompareFor();
        } else {
          this.fetchCustomChartDataFor(this.currentID, this.selectedFromDate, this.selectedToDate);
        }
      } else {
        if (this.currentID.length > 0) {
          if (this.chartType === 'multi') {
            this.fetchChartDataToCompareFor();
          } else {
            this.fetchChartDataFor(this.currentID, this.currentPeriod, this.currentTimeSeries);
          }
        }
      }
      this.storeChartOption(this.currentID, this.currentPeriod, this.currentTimeSeries, this.selectedToDate, this.selectedFromDate,
        this.chartType, this.indexToCompare);
    }else{
      this.indexNotFoundMsg = 'Can only select period within last 10 years.';
      this.indexNotInHeadline = true;
    }
  }

  compareCharts(event: any): void{
    const selectedIndices = event.map((ev: any) => ev.value);
    this.indexToCompare = this.shareService.EMIXIndices.indexLevels
      .filter((index: any) => selectedIndices.includes(index.indexName + ' (' + index.currency + ')')).map((index: any) => index.id);
    this.indexToCompare = [this.currentID , ...this.indexToCompare];
    this.chartSetting = this.indexToCompare.length > 1 ? 'custom' : 'default';
    this.chartType = this.indexToCompare.length > 1 ? 'multi' : 'single';
    this.getFromAndToDate();
    // @ts-ignore
    let validPeriod = (new Date(new Date().getFullYear() - 10, new Date().getMonth(), new Date().getDate())
    // @ts-ignore
      - new Date(this.selectedFromDate)) <= 0;
    if (this.currentPeriod !== 'custom'){
      validPeriod = true;
    }
    if (validPeriod) {
      this.indexNotInHeadline = false;
      this.fetchChartDataToCompareFor();
      this.storeChartOption(this.currentID, this.currentPeriod, this.currentTimeSeries, this.selectedToDate, this.selectedFromDate,
        this.chartType, this.indexToCompare);
    }else{
      this.indexNotFoundMsg = 'Can only select period within last 10 years.';
      this.indexNotInHeadline = true;
    }
  }

  fetchChartDataToCompareFor(): void{
    if (this.indexToCompare === undefined){
      this.utilService.removeChartFilerOptionFor(this.currentID);
      this.chartType = 'single';
      this.fetchChartDataFor(this.currentID, this.currentPeriod, this.currentTimeSeries);
    }else if (this.indexToCompare.length <= 5) {
      this.loader.show();
      this.chartDataLoaded = false;
      this.chartSetting = 'custom';
      this.getFromAndToDate();

      this.apiService.getChartDataToCompareForOnEMIX(this.indexToCompare.join('~'), this.currentPeriod, this.selectedFromDate,
        this.selectedToDate, this.currentTimeSeries).subscribe((resp: any) => {
        if (resp.error) {
          this.showAlert2 = true;
          this.alert2 = resp.errorMessage;
          this.chartType = 'single';
          this.utilService.removeChartFilerOptionFor(this.currentID);
        } else {
          this.chartDataLoaded = true;
          this.chartDatas = resp.chartDatas;
          this.chartDataFetching = false;
          // this.isRebased = this.chartType === 'multi';
          setTimeout(() => {
            this.chartPage?.updateSeries(this.isRebased);
          }, 100);
        }
        this.loader.hide();
      });
    }else{
      this.indexNotFoundMsg = 'Maximum 5 indices can be displayed on chart.';
      this.indexNotInHeadline = true;
    }
  }

  changeCompare(event: any): void {
    this.isRebased = event.value === 'Rebased';
    this.chartPage?.updateSeries(this.isRebased);
    this.getFromAndToDate();
    this.storeChartOption(this.currentID, this.currentPeriod, this.currentTimeSeries, this.selectedToDate, this.selectedFromDate,
      this.chartType, this.indexToCompare);
  }

  resetChart(): void{
    this.chartSetting = 'default';
    this.currentPeriod = 'YTD';
    this.selectedPeriod = 'YTD';
    this.dateRange = new RangeDateScreenerFilterModel();
    this.selectedFromDate = '';
    this.selectedToDate = '';
    this.currentTimeSeries = 'Price';
    this.selectedTimeSeries = 'Price';
    this.chartType = 'single';
    this.isRebased = true;
    this.indexToCompare = [this.currentID];
    this.resetDropdown = false;
    this.initialiseDropDown();
    this.initDropDown();
    this.initCompareChartDropdown();
    this.fetchChartDataFor(this.currentID, this.currentPeriod, this.currentTimeSeries);
    this.storeChartOption(this.currentID, this.currentPeriod, this.currentTimeSeries, '', '', this.chartType, this.indexToCompare);
  }

  fetchChartDataFor(indexID: string, period: string, timeSeries: string): void {
    if (!this.chartDataFetching && indexID) {
      this.chartDataLoaded = false;
      this.chartDataFetching = true;
      this.loader.show();
      if (this.currentPeriod !== 'custom') {
        this.dateRange = new RangeDateScreenerFilterModel();
      }
      if (period === 'No period selected') {
        this.removeChart();
      } else {
        this.chartSetting = period === 'YTD' && timeSeries === 'Price' && this.indexToCompare.length === 1 ? 'default' : 'custom';
        this.apiService.getChartDataForEMIXFor(indexID, period, timeSeries)
          .subscribe((resp: any) => {
            if (resp.error) {
              this.showAlert2 = true;
              this.alert2 = resp.errorMessage;
              this.chartType = 'single';
              this.utilService.removeChartFilerOptionFor(this.currentID);
            } else {
              this.chartDataLoaded = true;
              this.isRebased = false;
              this.chartType = 'single';
              this.chartData = resp.chartData;
              this.chartDataFetching = false;
              this.dateRange = new RangeDateScreenerFilterModel();
              setTimeout(() => {
                this.chartPage?.updateSeries(this.isRebased);
              }, 100);
            }
            this.loader.hide();
          });
      }
    }
  }

  fetchCustomChartDataFor(indexId: string, from: string, to: string): void {
    this.chartDataFetching = true;
    this.chartDataLoaded = false;
    this.chartSetting = 'custom';
    this.loader.show();
    this.apiService.getCustomEMIXChartDataFor(indexId, from, to, this.currentTimeSeries)
      .subscribe((resp: any) => {
      if (resp.error) {
        this.showAlert2 = true;
        this.alert2 = resp.errorMessage;
        this.chartType = 'single';
        this.utilService.removeChartFilerOptionFor(this.currentID);
      } else {
        this.chartType = 'single';
        this.chartDataFetching = false;
        this.chartData = resp.chartData;
        this.chartDataLoaded = true;
        this.isRebased = false;
        setTimeout(() => {
          this.chartPage?.updateSeries(this.isRebased);
        }, 100);
      }
      this.loader.hide();
    });
  }

  removeChart(): void{
    this.loader.show();
    setTimeout(() => {
      if (this.chartData) {
        this.chartData.chartSeries.data = [];
        this.chartData.chartSeries.name = this.currentTimeSeries;
        this.chartDataLoaded = false;
      }
      this.chartDataFetching = false;
      this.loader.hide();
    }, 1000);
  }

  fetchDetailsForID(id: string): void{
    this.loader.show();
    this.apiService.getIndexDetailForEMIX(id).subscribe((resp: any) => {
      if (resp.error) {
        this.showAlert1 = true;
        this.alert1 = resp.errorMessage;
      } else {
        this.response = resp;
        this.currentTab = this.response.indexName + ' (' + this.response.currency + ')';
        if (!this.tabList.includes(this.currentTab)){
          this.tabList.push(this.currentTab);
        }
        window.sessionStorage.setItem('tabListForEMIX', JSON.stringify(this.tabList));
        // this.initTimeSeriesDropDown();
        this.initCompareChartDropdown();
        this.fetchConstituentDataFor(this.response.eiCode);
        this.repopulateView();
        // this.initDropDown();
      }
      this.loader.hide();
    });

    if ((this.selectedPeriod !== null && this.selectedPeriod.length > 0) &&
      (this.selectedTimeSeries !== null && this.selectedTimeSeries.length > 0)) {
      if (this.selectedPeriod === 'custom'){
        this.dateRange.ngbFromDate = new NgbDate(new Date(this.selectedFromDate).getFullYear(),
          new Date(this.selectedFromDate).getMonth() + 1, new Date(this.selectedFromDate).getDate());
        this.dateRange.ngbToDate = new NgbDate(new Date(this.selectedToDate).getFullYear(),
          new Date(this.selectedToDate).getMonth() + 1, new Date(this.selectedToDate).getDate());
        this.reinitialisePeriodPicker();
        this.currentPeriod = this.selectedPeriod;
        if (this.chartType === 'multi') {
          this.fetchChartDataToCompareFor();
        }else{
          this.fetchCustomChartDataFor(id, this.selectedFromDate, this.selectedToDate);
        }
      }else {
        if (this.chartType === 'multi') {
          this.fetchChartDataToCompareFor();
        }else{
          this.fetchChartDataFor(id, this.selectedPeriod, this.selectedTimeSeries);
        }
      }
    } else {
      this.fetchChartDataFor(id, this.periodData[0], this.timeSeriesData[0]);
    }
  }

  fetchConstituentDataFor(indexID: string): void{
    this.profileLoading = true;
    this.constituentData = undefined;
    this.apiService.getConstituentDataForEMIX(indexID).subscribe((resp: any) => {
      this.constituentData = resp;
      this.profileLoading = false;
    });
  }


  expandView(cardName: string): void {
    if (this.expanded) {
      this.expanded = false;
      this.visibleCards = ['chart', 'profile', 'analytics', 'constituent'];
    } else {
      this.expanded = true;
      this.currentCard = cardName;
      this.changeView(cardName);
    }
    this.storeView();
  }

  changeView(event: any): void {
    this.visibleCards.splice(0);
    switch (event) {
      case 'CHART':
        this.visibleCards.push('chart');
        break;
      case 'INDEX PROFILE':
        this.visibleCards.push('profile');
        break;
      case 'INDEX PERFORMANCE & ANALYTICS':
        this.visibleCards.push('analytics');
        break;
      case 'CONSTITUENT':
        this.visibleCards.push('constituent');
        break;
    }
    this.storeView();
  }

  storeView(): void {
    const tabDetails = {
      tabName: this.currentTab,
      state: {
        visibleCards: this.visibleCards,
        expanded: this.expanded
      }
    };
    const index = this.currentView.findIndex((view: any) => view.tabName === tabDetails.tabName);
    if (index > -1) {
      // @ts-ignore
      this.currentView.splice(index, 1, tabDetails);
    } else {
      // @ts-ignore
      this.currentView.push(tabDetails);
    }
    localStorage.setItem('tabViewState', JSON.stringify(this.currentView));
  }

  repopulateView(): void {
    // @ts-ignore
    JSON.parse(localStorage.getItem('tabViewState')).forEach((view: any) => {
      if (view.tabName === this.currentTab) {
        this.visibleCards = view.state.visibleCards;
        if (this.visibleCards.length === 1) {
          // @ts-ignore
          this.currentCard = this.cards.find((card: string) => {
            if (card.includes(this.visibleCards[0].toUpperCase())) {
              return card;
            }
          });
        }
        if (!this.currentCard) {
          this.currentCard = 'CONSTITUENT';
        }
        this.expanded = view.state.expanded;
      }
    });

    this.profileData = undefined;
    if (this.currentPeriod !== 'custom' && this.currentPeriod !== 'No period selected') {
      this.dateRange = new RangeDateScreenerFilterModel();
    }
  }

  downloadHistory(): void {
    this.loader.show();
    if (this.currentPeriod === 'No period selected'){
      this.downloadAsCSV(this.currentTimeSeries);
      this.loader.hide();
    }else if (this.currentPeriod === 'custom'){
     this.getFromAndToDate();
      // @ts-ignore
     const validPeriod = (new Date(new Date().getFullYear() - 10, new Date().getMonth(), new Date().getDate()) -
      // @ts-ignore
        new Date(this.selectedFromDate)) <= 0;

     if (validPeriod) {
        if (this.chartType === 'multi') {
          if (this.indexToCompare.length <= 5) {
            this.apiService.getDataToDownloadForIndicesForEMIX(this.indexToCompare.join('~'), this.currentPeriod, this.selectedFromDate,
              this.selectedToDate, this.currentTimeSeries, this.getFileName(this.currentTimeSeries)).subscribe(() => {
              this.loader.hide();
              this.downloadDataForIndicesAsCSV();
            });
          } else {
            this.indexNotFoundMsg = 'Maximum 5 indices data can be downloaded.';
            this.indexNotInHeadline = true;
            this.loader.hide();
          }
        } else {
          this.apiService.getDataToDownloadForCustomForEMIX(this.currentID, this.selectedFromDate,
            this.selectedToDate, this.currentTimeSeries, this.getFileName(this.currentTimeSeries)).subscribe(() => {
            this.loader.hide();
            this.downloadAsCSV(this.currentTimeSeries);
          });
        }
      }else{
        this.indexNotFoundMsg = 'Can only select period within last 10 years.';
        this.indexNotInHeadline = true;
        this.loader.hide();
      }
    }else {
      if (this.chartType === 'multi') {
        if (this.indexToCompare.length <= 5) {
          this.apiService.getDataToDownloadForIndicesForEMIX(this.indexToCompare.join('~'), this.currentPeriod, '', '',
            this.currentTimeSeries, this.getFileName(this.currentTimeSeries)).subscribe(() => {
            this.loader.hide();
            this.downloadDataForIndicesAsCSV();
          });
        }else{
          this.indexNotFoundMsg = 'Maximum 5 indices data can be downloaded.';
          this.indexNotInHeadline = true;
          this.loader.hide();
        }
      }else {
        this.apiService.getDataToDownloadForEMIX(this.currentID, this.currentPeriod, this.currentTimeSeries,
          this.getFileName(this.currentTimeSeries)).subscribe(() => {
          this.loader.hide();
          this.downloadAsCSV(this.currentTimeSeries);
        });
      }
    }
  }

  downloadAsCSV(currentTimeSeries: string): void{
    // const headerList = ['Date', 'ISIN', 'Name', currentTimeSeries];
    // const dataToExport = this.utilService.convertToCSV(this.response.isinTri, this.response.indexName,
    //   headerList, resp ? resp.chartData.chartSeries.data : []);
    const fileName = this.getFileName(currentTimeSeries);
    const URL = this.apiService.createGetPath('/indices/createExcel', ['fileName', encodeURIComponent(fileName)]);
    window.open(URL);
    // this.utilService.downloadFile(dataToExport, fileName);
  }

  downloadConstituentData(): void{
    const headerList = ['Report Date', 'Rebalance Date', 'Issuer', 'Coupon in %', 'Maturity Date', 'Index Weight in %'];
    const dataToExport = this.utilService.convertConstituentDataToCSV(headerList, this.constituentData);
    const fileName = this.response.indexName + '_constituentData';
    this.utilService.downloadFile(dataToExport, fileName);
  }

  downloadDataForIndicesAsCSV(): void{
    // const header1 = ['Performance Indicator:', resp.chartDatas[0].selectedTimeSeries];
    // const dataToDownload: any[] = [];
    // // @ts-ignore
    // dataToDownload.Date = resp.chartDatas[0].chartSeries.data.map((dt: any) => dt.date);
    // resp.chartDatas.forEach((data: any) => {
    //   dataToDownload[data.chartSeries.name] = data.chartSeries.data.map((dt: any) => dt.value);
    // });
    // const headerList: string[] = [];
    // Object.keys(dataToDownload).forEach((key: string) => headerList.push(key));
    // const dataToExport = this.utilService.convertMultipleIndexDataToCSV(header1, headerList, dataToDownload);
    const fileName = this.response.indexName + ' (' + this.response.currency + ')' + '_Compare_' + this.currentPeriod + '_' +
      this.currentTimeSeries;
    const URL = this.apiService.createGetPath('/indices/createExcel', ['fileName', encodeURIComponent(fileName)]);
    window.open(URL);
    // this.utilService.downloadFile(dataToExport, fileName);
  }

  closeAlert(alert: string): void {
    switch (alert) {
      case 'alert1':
        this.showAlert1 = false;
        break;
      case 'alert2':
        this.showAlert2 = false;
        break;
      case 'alert3':
        this.showAlert3 = false;
        break;
      case 'indexNotFoundMsg':
        this.indexNotInHeadline = false;
        if (this.indexNotFoundMsg === 'Invalid Request.') {
          this.route.navigateByUrl('iBoxx/Screener');
        }
        break;
    }
  }

  getFileName(currentTimeSeries: string): string{
    return this.response.indexName + '_' + this.currentPeriod + '_' + currentTimeSeries;
  }
}
